import React from 'react';
var GMOptsContext = /*#__PURE__*/React.createContext();
export default GMOptsContext;